import React, { useEffect, useState } from "react";
import RecursiveTxns from "../Recursive/AddAndEditRTxns";
import OneTimeTxn from "./OneTimeTxn";
import { useLocation } from "react-router-dom";
import { toast } from "sonner";

function NewTxn({ Txntype }) {
  const [txnType, setTxnType] = useState(Txntype || "onetime");
  const location = useLocation();
  const [isKHATA, setIsKHATA] = useState(false);

  useEffect(() => {
    if (location.pathname === "/") {
      setIsKHATA(false);
    } else if (location.pathname === "/khatabook") {
      setIsKHATA(true);
    }
  }, []);

  return (
    <div className="d-flex flex-column bg-white mb-3 mb-md-5">
      {isKHATA &&
        (<div className="btn-group w-100 py-2 py-md-3" role="group">
          <button
            type="button"
            className={`btn btn-outline-danger btn-block ${txnType === "onetime" ? "active" : ""}`}
            onClick={(e) => setTxnType("onetime")}
          >
            One Time
          </button>
          <button
            type="button"
            className={`btn btn-outline-danger btn-block ${txnType === "recurring" ? "active" : ""}`}
            onClick={(e) => setTxnType("recurring")}
          >
            Recurring
          </button>
        </div>)
      }
      {txnType === "onetime" ? <OneTimeTxn /> : <RecursiveTxns />}
    </div>
  );
}
export default NewTxn;